import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

import { Ticket, TicketItem } from 'src/app/models';

export type NotesModalResult = string;

export interface NotesModalProps {
  label: string;
  selectedTicket?: Ticket;
  selectedTicketItem?: TicketItem;
}

@Component({
  templateUrl: './notes.modal.html',
  styleUrls: ['./notes.modal.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotesModal implements OnInit {
  @Input() label: string;
  @Input() selectedTicket?: Ticket;
  @Input() selectedTicketItem?: TicketItem;

  private readonly controls = {
    notes: new FormControl(null, Validators.required)
  };

  form = new FormGroup(this.controls);

  constructor(private readonly modalCtrl: ModalController) {}

  ngOnInit() {
    if (!this.selectedTicket && !this.selectedTicketItem) {
      return;
    }

    const notes = this.selectedTicketItem
      ? this.selectedTicketItem.notes
      : this.selectedTicket.delivery_note;
    this.controls.notes.setValue(notes);
    this.form.markAsPristine();
  }

  onSaveNotes() {
    if (this.form.invalid) {
      return;
    }

    this.onCloseModal(this.form.value.notes);
  }

  onCloseModal(note?: string) {
    this.modalCtrl.dismiss(note?.trim());
  }
}
